import {makeStyles} from '@material-ui/core/styles'
import {createMuiTheme} from '@material-ui/core';
import {estilosTextosPrincipales, colores} from '../../../AppStyle'

export const customStyle = makeStyles ({
 
    /***********COMPUTER VERSION***********/

    searchAutocomplete:{
        width: 'fit-content',
        height: '48px',
    },

    searchTextField:{   
        width: '280px',
        height: '48px',
        margin: '0px',

    },

    searchButton:{
        borderBottomRightRadius:'5px', /**Que tenga la esquina curvo */
        borderTopRightRadius:'5px',
        height: '48px',
        width: '48px',
        '&.Mui-focusVisible': {
            boxShadow: '#087021 0 0 10px',       
        },
        '&:hover':{
            boxShadow: '#087021 0 0 10px', 

        }
    },
    searchImg:{
        height: '48px',
        width: '48px',  
        borderBottomRightRadius:'5px', /**Que tenga la esquina curvo */
        borderTopRightRadius:'5px'
    },

    /***********PHONE VERSION***********/

    searchAutocompletePhone:{
        width: 'fit-content',
        height: '40px',
    },

    searchTextFieldPhone:{   
        width: '288px',
        height: '40px',
        margin: '0px',
    },

    searchButtonPhone:{
        borderRadius:'0', /**Que sea un cuadrado */
        height: '40px',
        width: '40px',
        borderBottomRightRadius:'5px', /**Que tenga la esquina curvo */
        borderTopRightRadius:'5px',
        '&$focused': {
            boxShadow: '#087021 0 0 10px',       
        },        
    },
    searchImgPhone:{
        height: '40px',
        width: '40px',
        borderBottomRightRadius:'5px', /**Que tenga la esquina curvo */
        borderTopRightRadius:'5px'
    }
});

export function overrideStyleF(condition){

    const overrideStyle = createMuiTheme({
        overrides: {
    
            MuiOutlinedInput: {
                root: {
                    ...(condition ? { height: '40px' } : { height: '48px' }),                    
                    alignContent: 'center',
                    borderBottomRightRadius: '0px',
                    borderTopRightRadius: '0px',
                    border: `1px solid ${colores.principales.apoyo}`,
                    ...estilosTextosPrincipales.body1,
                    '&.Mui-focused':{
                        border: `1px solid ${colores.principales.principal}`,
                    },
                    '&:hover':{
                        border: `1px solid ${colores.principales.principal}`,
                    }
                },
                notchedOutline:{
                    borderStyle: 'none',
                }
            },
            MuiInputBase: {
                input: {
                    '&::placeholder': {
                        color: colores.escalaGrises.apoyo,
                    },
                },
            },
        }
    });

    return overrideStyle;
}


